
import { Modal, Typography, Form, Input, Select } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";
import { useEffect } from "react";

const { Title } = Typography;

const OfferStatusModal = ({
    isOpen,
    closeModal,
    title = "Update Status",
    handleFinish,
    btnText = "Update",
    status=''
}) => {

    const options = ["Active", "Inactive", "Expired"]
    const [form] = Form.useForm();

    useEffect(()=>{
        if(status){
              form.setFieldValue("status", status);
        }

    }, [status])

    return (
        <>
            <Modal
                open={!!isOpen}
                centered
                title={
                    <Title level={2} className="font-abhaya !mb-0">
                        {title}
                    </Title>
                }
                onCancel={() => {
                    closeModal();
                    form.resetFields()
                }}
                destroyOnHidden
                width={400}
                footer={null}
                className="form-css-5"
            >
                <div >
                    <Form form={form} layout="vertical" onFinish={handleFinish}
                        requiredMark={false}>

                        <Form.Item
                            name="status"
                            rules={[{ required: true, message: "Please select status" }]}
                        >
                            <Select placeholder="Please select status">
                                {options.map((item) => (
                                    <Select.Option key={item} value={item}>
                                        {item}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <div className="w-full flex justify-center mt-4">

                            <PrimaryButton
                                text={btnText}
                                type="submit"
                                htmlType="submit"
                                className="me-[30px]"
                            />

                        </div>

                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default OfferStatusModal;
